import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { xeroQueryKeys } from "./xeroQueryKeys";

export const useQueryXeroGetIntegrationStatus = ({
  api,
  refetchOnWindowFocus,
  clubId,
  enabled,
}: {
  api: ApiType;
  refetchOnWindowFocus?: boolean;
  clubId: number;
  enabled: boolean;
}) =>
  useQuery({
    queryKey: xeroQueryKeys.getIntegrationStatus(clubId),
    queryFn: async () => (await api.xeroApi.getIntegrationStatus()).data,
    refetchOnWindowFocus,
    enabled,
  });
